import { ArtistPortalWebSessionState } from 'fym-shared/src/smartlinks/artistPortals';
import { ServiceConnection } from '../../../../redux/api/fymAPI.types';

/**
 * Which note the web SoundCloud card shows about the second sign-in (SoundCloud Insights, design
 * soundcloud-insights b1). The web cannot capture a session of soundcloud.com, so the note sends
 * the artist to the Music24 app. Null: no note (no second sign-in on this deploy, an old server, or
 * a card that is not connected).
 */
export function soundCloudInsightsNoteState(
  connection: Pick<ServiceConnection, 'webSession' | 'artist'>,
  cardState: string
): ArtistPortalWebSessionState | null {
  const { webSession } = connection;
  if (webSession === undefined || connection.artist === null) {
    return null;
  }
  if (cardState !== 'connected' && cardState !== 'firstRead') {
    return null;
  }
  if (webSession.state === 'none' && !webSession.available) {
    return null;
  }
  return webSession.state;
}
